// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"56":"f09c7d68","570":"75db0ab0","724":"195cdcce"}[chunkId] + ".css";
};